import { DataURISVG } from './data-uri-svg';

const image = {
  DataURISVG: DataURISVG
};

export default image;
